import { render, staticRenderFns } from "./FiltersTerapias.vue?vue&type=template&id=8e44918c"
import script from "./FiltersTerapias.vue?vue&type=script&lang=js"
export * from "./FiltersTerapias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports